export default "__VITE_ASSET__CxrHWVO$__"